var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "compare-column" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "compare-content" }, [
      _c(
        "div",
        { staticClass: "compare-list" },
        _vm._l(_vm.bidParityList, function(bidDoc, index) {
          return _c("div", { staticClass: "compare-item" }, [
            _c("a", [_vm._v(_vm._s(bidDoc.merchantName))]),
            _vm._v(" "),
            _c("span", [
              _vm._v("总报价（元）："),
              _c("span", { staticClass: "font-red" }, [
                _vm._v(_vm._s(bidDoc.offerPrice || "无"))
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "price" }),
            _vm._v(" "),
            _c(
              "i",
              {
                staticClass: "close-icon",
                on: {
                  click: function($event) {
                    _vm.removeBidParity(index)
                  }
                }
              },
              [_vm._v("×")]
            )
          ])
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "compare-operate" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-mini",
            on: {
              click: function($event) {
                _vm.openBidParityDlg()
              }
            }
          },
          [_vm._v("对比")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "compare-title" }, [
      _c("span", [_vm._v("对比栏")]),
      _vm._v(" "),
      _c("span", { staticClass: "comments" }, [_vm._v("最多可加入10个")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4929c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4929c7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/ParityCenter.vue
// module id = 3351
// module chunks = 0